/* eslint-disable max-len */
import React, { useContext } from "react";
import { ThemeContext } from "../../App";
import "./ThemeButton.css";


/**
 * Render Theme button
 * @return {JSX.Element} App root directory
 */
export default function ThemeButton(): JSX.Element {
	const { theme, toggleTheme } = useContext(ThemeContext);

	const img = (theme === "light" ?
		<svg
			xmlns="http://www.w3.org/2000/svg"
			enableBackground="new 0 0 20 20"
			height="100%"
			width="100%"
			viewBox="0 0 20 20"
			fill="#000000"
		>
			<rect
				fill="none"
				height="20px"
				width="20px"
			/>
			<path d="M10,3c-3.87,0-7,3.13-7,7s3.13,7,7,7s7-3.13,7-7c0-0.36-0.03-0.72-0.08-1.06C16.16,10,14.91,10.7,13.5,10.7 c-2.32,0-4.2-1.88-4.2-4.2c0-1.41,0.7-2.66,1.76-3.42C10.72,3.03,10.36,3,10,3L10,3z"/>
		</svg> :
		
		<svg
			xmlns="http://www.w3.org/2000/svg"
			enableBackground="new 0 0 20 20"
			height="100%"
			width="100%"
			viewBox="0 0 20 20"
			fill="#FFFFFF"
		>
			<rect
				fill="none"
				height="20"
				width="20"
			/>
			<path d="M10,6c2.21,0,4,1.79,4,4s-1.79,4-4,4s-4-1.79-4-4S7.79,6,10,6L10,6z M3.75,10.75c0.41,0,0.75-0.34,0.75-0.75 c0-0.41-0.34-0.75-0.75-0.75h-2C1.34,9.25,1,9.59,1,10s0.34,0.75,0.75,0.75H3.75z M18.25,10.75c0.41,0,0.75-0.34,0.75-0.75 c0-0.41-0.34-0.75-0.75-0.75h-2c-0.41,0-0.75,0.34-0.75,0.75s0.34,0.75,0.75,0.75H18.25z M9.25,3.75C9.25,4.16,9.59,4.5,10,4.5 c0.41,0,0.75-0.34,0.75-0.75v-2C10.75,1.34,10.41,1,10,1S9.25,1.34,9.25,1.75V3.75z M13.89,5.05c-0.29,0.29-0.29,0.77,0,1.06 s0.77,0.29,1.06,0l1.06-1.06c0.29-0.29,0.29-0.77,0-1.06c-0.29-0.29-0.77-0.29-1.06,0L13.89,5.05z M3.99,14.95 c-0.29,0.29-0.29,0.77,0,1.06s0.77,0.29,1.06,0l1.06-1.06c0.29-0.29,0.29-0.77,0-1.06c-0.29-0.29-0.77-0.29-1.06,0L3.99,14.95z M5.05,6.11c0.29,0.29,0.77,0.29,1.06,0s0.29-0.77,0-1.06L5.05,3.99c-0.29-0.29-0.77-0.29-1.06,0s-0.29,0.77,0,1.06L5.05,6.11z M14.95,16.01c0.29,0.29,0.77,0.29,1.06,0s0.29-0.77,0-1.06l-1.06-1.06c-0.29-0.29-0.77-0.29-1.06,0c-0.29,0.29-0.29,0.77,0,1.06 L14.95,16.01z M9.25,18.25C9.25,18.66,9.59,19,10,19c0.41,0,0.75-0.34,0.75-0.75v-2c0-0.41-0.34-0.75-0.75-0.75 s-0.75,0.34-0.75,0.75V18.25z"/>
		</svg>
	);

	return (
		<div className="toolBarButtonContainer">

			<button
				id="themeButton"
				className="toolBarButton"
				onClick={toggleTheme}
			>
				{
					img
				}
			</button>

		</div>
	);
}
